import classNames from "classnames";
import React, { ReactElement } from "react";
import { AppButton } from "./AppButton";

type AppActionCardColor = "green" | "blue" | "white";

interface Props
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  color: AppActionCardColor;
  text: string;
  action: string;
  onClick: () => void;
}

export function AppActionCard(props: Props): ReactElement {
  const { color, text, action, onClick, ...rest } = props;

  return (
    <div {...rest} className={classNames("AppActionCard", rest.className)} data-color={color}>
      <span className="AppActionCard__text">{props.text}</span>
      <AppButton
        color={props.color === "white" ? "primary" : "white"}
        variant="outline"
        onClick={onClick}
      >
        {props.action}
      </AppButton>
    </div>
  );
}
